// @flow
import React from 'react';
import { FormattedMessage } from 'translations';
import CheckboxField from 'mz-ui-kit/form/CheckboxField';
import NumberField from 'mz-ui-kit/form/NumberField';

import { NumberFieldWrapper, FilterSuitcase, BlackLabel } from './elements'

type Props = {
  onChange: (param: boolean) => void,
  value: Number
};

const messages = {
  luggageAmount: { id: 'SEARCH_RESULTS.LUGGAGE_AMOUNT' }
};

const MINIMUM_LUGGAGE_COUNT = 0;

/**
 * Filter by suitcase numbers
 * @param {Function} onChange, on/off checkbox value
 * @param {Number} value, on/off
 *
 * @return React.Node
 */
export default function FilterSuitcases ({ onChange, value }: Props) {
  const hasLuggage = value > 0;
  const resetNumber = () => {
    onChange(MINIMUM_LUGGAGE_COUNT);
  }

  return (
    <FilterSuitcase>
      <CheckboxField
        input={{
          value: hasLuggage,
          onChange: resetNumber
        }}
        disabled={!hasLuggage}
        label={(
          <BlackLabel>
            <FormattedMessage
              {...messages.luggageAmount}
            />
          </BlackLabel>
        )}
      />
      <NumberFieldWrapper>
        <NumberField
          appearance='material-wo-baseline'
          min={MINIMUM_LUGGAGE_COUNT}
          input={{
            value,
            onChange
        }}/>
      </NumberFieldWrapper>
    </FilterSuitcase>
  );
}
